<template>
  <div class="sign-user-picker">
    <span class="sign-role-label">{{ roleLabel }}：</span>
    <span class="sign-line">
      <template v-if="mode === 'edit'">
        <el-select
          v-if="!hasSign"
          :value="null"
          filterable
          clearable
          placeholder="选人"
          size="mini"
          class="sign-select"
          @change="onSelect"
        >
          <el-option
            v-for="u in users"
            :key="u.id"
            :label="u.xm + (u.qz_img ? '' : '（未上传签名）')"
            :value="u.id"
            :disabled="!u.qz_img"
          />
        </el-select>
        <template v-else>
          <img :src="displayImg" :alt="inner.xm" class="sign-img" />
          <i class="sign-repick el-icon-edit" title="更换" @click.stop="clearSelection" />
        </template>
      </template>
      <template v-else>
        <img v-if="displayImg" :key="displayImg" :src="displayImg" :alt="inner && inner.xm" class="sign-img" />
        <span v-else-if="inner && inner.xm" class="sign-name">{{ inner.xm }}</span>
        <span v-else class="sign-empty"> </span>
      </template>
    </span>
  </div>
</template>

<script>
import api from '@/utils/api'

import { resolveAssetUrl } from '@/utils/user'

export default {
  name: 'SignUserPicker',
  props: {
    roleLabel: { type: String, default: '' },
    value: { type: Object, default: null },
    mode: { type: String, default: 'edit' }
  },
  data() {
    return {
      users: [],
      inner: null
    }
  },
  computed: {
    hasSign() {
      return !!(this.inner && this.inner.img)
    },
    displayImg() {
      return resolveAssetUrl(this.inner && this.inner.img)
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.inner = v && (v.img || v.yhid || v.xm) ? { ...v } : null
      }
    }
  },
  mounted() {
    this.loadUsers()
  },
  methods: {
    async loadUsers() {
      try {
        const res = await api.get('yn_yh_list')
        this.users = res.data || []
      } catch (e) {
        this.users = []
      }
    },
    onSelect(yhid) {
      if (!yhid) {
        this.clearSelection()
        return
      }
      const u = this.users.find(x => String(x.id) === String(yhid))
      if (!u || !u.qz_img) {
        this.$message.warning('该用户尚未上传电子签名')
        return
      }
      const sign = { yhid: u.id, xm: u.xm, img: u.qz_img }
      this.inner = sign
      this.$emit('input', sign)
      this.$emit('change', sign)
    },
    clearSelection() {
      this.inner = null
      this.$emit('input', null)
      this.$emit('change', null)
    }
  }
}
</script>

<style scoped>
.sign-user-picker {
  display: flex;
  align-items: flex-end;
  gap: 4px;
  min-width: 0;
}
.sign-role-label {
  font-size: 10pt;
  line-height: 1.15;
  max-width: 5.5em;
  white-space: normal;
  word-break: keep-all;
  text-align: right;
  flex-shrink: 0;
  align-self: flex-end;
  padding-bottom: 2px;
}
.sign-line {
  width: 128px;
  flex: none;
  flex-shrink: 0;
  height: 36px;
  border-bottom: 1px solid #000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  overflow: hidden;
}
.sign-select {
  width: 100%;
}
.sign-select >>> .el-input__inner {
  border: none;
  background: transparent;
  height: 30px;
  line-height: 30px;
  padding: 0 24px 0 4px;
  font-size: 11pt;
}
.sign-img {
  width: 124px;
  height: 32px;
  max-width: 124px;
  max-height: 32px;
  object-fit: contain;
  object-position: center bottom;
  display: block;
  margin-bottom: 1px;
}
.sign-repick {
  position: absolute;
  right: 0;
  bottom: 2px;
  font-size: 12px;
  color: #909399;
  cursor: pointer;
  padding: 2px;
  line-height: 1;
}
.sign-repick:hover {
  color: #409eff;
}
.sign-name {
  font-size: 11pt;
  line-height: 1;
  padding-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 124px;
}
.sign-empty {
  display: inline-block;
  width: 100%;
  height: 1px;
}
</style>
